export const addConsumer = (consumer, peerId) =>
	({
		type: 'ADD_CONSUMER',
		payload: { consumer, peerId }
	});

export const removeConsumer = (consumerId, peerId) =>
	({
		type: 'REMOVE_CONSUMER',
		payload: { consumerId, peerId }
	});

export const clearConsumers = () =>
	({
		type: 'CLEAR_CONSUMERS'
	});

export const setConsumerPaused = (consumerId, originator) =>
	({
		type: 'SET_CONSUMER_PAUSED',
		payload: { consumerId, originator }
	});

export const setConsumerResumed = (consumerId, originator) =>
	({
		type: 'SET_CONSUMER_RESUMED',
		payload: { consumerId, originator }
	});

export const setConsumerTrack = (consumerId, track) =>
	({
		type: 'SET_CONSUMER_TRACK',
		payload: { consumerId, track }
	});
